var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUser = function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.321 6.373a5.28 5.28 0 1 1-10.558 0 5.28 5.28 0 0 1 10.558 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.925 18.878a9.184 9.184 0 0 0-17.831.026"
  }))));
};
export { SvgIconUser as ReactComponent };
export default __webpack_public_path__ + "images/Icon_User.svg";